import { useMutation } from "urql";

import { UpdateRiskReviewDocument } from "../../../graphql/generated.ts";

export const useUpdateRiskReview = () => useMutation(UpdateRiskReviewDocument);
